import styled from 'styled-components';
import { Card } from '../../element';

export const ServiceItem = styled(Card)`
  background: #f5f7fa;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const Description = styled.div`
  font-size: 12px;
  line-height: 18px;
`;
